module.exports = __webpack_public_path__ + "static/poke-the-box-6c9e479080322bc22ca2c9e0beba9c30.jpg";